import { useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { SchoolSelect } from '../../components/common';
import { t, type MessageKey } from '../../i18n';
import { AssetsTab } from './AssetsTab';
import { StockTab } from './StockTab';
import { SuppliersTab } from './SuppliersTab';

type Tab = 'stock' | 'suppliers' | 'assets';

export function InventoryPage() {
  const { can } = useAuth();
  const [schoolId, setSchoolId] = useState('');
  const [tab, setTab] = useState<Tab>('stock');
  const tabs: Tab[] = [];
  if (schoolId && can('inventory.view', schoolId)) tabs.push('stock', 'suppliers', 'assets');
  const active = tabs.includes(tab) ? tab : tabs[0];

  return (
    <div className="mx-auto max-w-5xl space-y-4">
      <h1 className="text-2xl font-bold">{t('inv.title')}</h1>
      <SchoolSelect value={schoolId} onChange={setSchoolId} />
      {schoolId && active && (
        <>
          <div
            role="tablist"
            aria-label={t('inv.title')}
            className="flex flex-wrap gap-1 border-b border-slate-200"
          >
            {tabs.map((name) => (
              <button
                key={name}
                role="tab"
                type="button"
                aria-selected={active === name}
                onClick={() => setTab(name)}
                className={`-mb-px border-b-2 px-4 py-2 text-sm font-medium ${active === name ? 'border-brand-700 text-brand-700' : 'border-transparent text-slate-600'}`}
              >
                {t(`inv.tab.${name}` as MessageKey)}
              </button>
            ))}
          </div>
          <div role="tabpanel">
            {active === 'stock' && <StockTab schoolId={schoolId} />}
            {active === 'suppliers' && <SuppliersTab schoolId={schoolId} />}
            {active === 'assets' && <AssetsTab schoolId={schoolId} />}
          </div>
        </>
      )}
    </div>
  );
}
